import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "overflow-x-auto" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Change ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Terror status"),
    /*#__PURE__*/_createElementVNode("th", null, "Document status"),
    /*#__PURE__*/_createElementVNode("th", null, "First name"),
    /*#__PURE__*/_createElementVNode("th", null, "Last name"),
    /*#__PURE__*/_createElementVNode("th", null, "Creator"),
    /*#__PURE__*/_createElementVNode("th", null, "Change state"),
    /*#__PURE__*/_createElementVNode("th", null, "Reset")
  ])
], -1)
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row space-x-2"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-success btn-sm" }, "Approve", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-error btn-sm" }, "Deny", -1)
const _hoisted_10 = [
  _hoisted_9
]

import { ref } from "vue";

import { IspsTruckerChangeTO } from "@/services/api-client/client";
import { isAdmin } from "@/util/role-util";
import { useUserStore } from "@/observables/store/user-store";


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryTable',
  props: {
    users: {}
  },
  emits: ["approve"],
  setup(__props: any, { emit: __emit }) {

const userStore = useUserStore();
const user = userStore.getUser();

const emit = __emit;

const getOnlyRelevantChanges = (changes: IspsTruckerChangeTO[]) => {
  //TODO: backend fix, they are showing in oldest order on top
  return changes.filter(
    (e) =>
      e.state === "PENDING" || e.state === "SYSTEM" || e.state === "APPROVED"
  );
};

const getCreatorName = (change: IspsTruckerChangeTO) => {
  if (change.state === "SYSTEM") {
    return "SYSTEM";
  }

  return `${change.creator?.firstName} ${change.creator?.lastName}`;
};

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getOnlyRelevantChanges(props.users!), (change) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: change.id
          }, [
            _createElementVNode("td", null, _toDisplayString(change.id), 1),
            _createElementVNode("td", null, _toDisplayString(change.terrorStatus), 1),
            _createElementVNode("td", null, _toDisplayString(change.documentStatus), 1),
            _createElementVNode("td", null, _toDisplayString(change.firstName), 1),
            _createElementVNode("td", null, _toDisplayString(change.lastName), 1),
            _createElementVNode("td", null, _toDisplayString(getCreatorName(change)), 1),
            _createElementVNode("td", null, _toDisplayString(change.state), 1),
            _createElementVNode("td", null, _toDisplayString(change.reset), 1),
            _createElementVNode("th", null, [
              (
                _unref(isAdmin)(_unref(userStore).getUser()?.roles ?? []) &&
                change.state === 'PENDING' &&
                change.creator?.id != _unref(user)?.id
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.$emit('approve', { approve: true, id: change.id! }))
                    }, _hoisted_7, 8, _hoisted_5),
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.$emit('approve', { approve: false, id: change.id! }))
                    }, _hoisted_10, 8, _hoisted_8)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})